module.exports = __webpack_public_path__ + "img/167_thumbnail.8ccfd3a9.jpg";